import type { FC, ReactNode } from 'react'
import type { LegalSection } from '@/components/landing/legal/legal-page'

import { LegalPage } from '@/components/landing/legal/legal-page'

const sections: LegalSection[] = [
    {
        id: 'what-we-collect',
        title: "What we collect",
        body: <p>What you enter in the quote form, meaning your ZIP code, contact details and answers about your door, plus a photo if you choose to add one. If you use the contact form, we keep your name, email, phone number if given, and your message.</p>
    },
    {
        id: 'why',
        title: "Why we collect it",
        body: <p>So we can price your job and book your visit.</p>
    },
    {
        id: 'who-sees-it',
        title: "Who can see it",
        body: <p>Our office team. A financing partner sees it only if you apply for financing.</p>
    },
    {
        id: 'email',
        title: "Email",
        body: <p>Your request is delivered to our office team by email. Emails sent from this site may track opens and clicks, which lets us confirm that a request came through.</p>
    },
    {
        id: 'how-long',
        title: "How long we keep it",
        body: <p>We keep your details for 24 months.</p>
    },
    {
        id: 'your-choices',
        title: "Your choices",
        body: (
            <p>
                To have your details deleted, email us at{' '}
                <a href='mailto:privacy@liftlinedoor.example' className='font-medium text-ink underline underline-offset-4 hover:text-ember'>
                    privacy@liftlinedoor.example
                </a>
                .
            </p>
        )
    },
    {
        id: 'cookies',
        title: "Cookies",
        body: <p>We use basic analytics and nothing more. Any quote list you build stays in your browser tab and is cleared when you close the tab.</p>
    }
]

const PrivacyPage: FC = (): ReactNode => {
    return (
        <LegalPage
            title="Privacy policy"
            description="What Liftline Door Co. collects through the quote form, why we collect it, who sees it and how long we keep it."
            note="This is template text for Liftline Door Co., written as a starting point and not as legal advice. Replace it with a policy reviewed for your state."
            sections={sections}
        />
    )
}

export default PrivacyPage
